import useABTestValue from '@hooks/useABTestValue'

type SharingIconType = 'grey' | 'colored' | 'ghost'

type SharingIconStyles = {
  primary: SharingIconType
  secondary: SharingIconType
}

export type UseShowSharingIcons = () => SharingIconStyles

const useShowSharingIcons: UseShowSharingIcons = () => {
  const abTestValue = useABTestValue('showSharingIcons')
  const styles: Record<string, SharingIconStyles> = {
    ColoredGrey: { primary: 'colored', secondary: 'grey' },
    Ghost: { primary: 'ghost', secondary: 'ghost' },
    Grey: { primary: 'grey', secondary: 'grey' },
    default: { primary: 'colored', secondary: 'ghost' },
  }

  return styles[abTestValue || 'default']
}

export default useShowSharingIcons
